// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-popup.duplicate-document-popup p {
  margin-top: 0;
}
.confirmation-popup.duplicate-document-popup .duplicate-document-popup-body {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
}
.confirmation-popup.duplicate-document-popup .buttons {
  margin-top: 3.2rem;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/ConfirmationPopup/DuplicateDocumentPopup/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AADJ;AAIE;EACE,kBAAA;EACA,yBAAA;AAFJ","sourcesContent":[".confirmation-popup.duplicate-document-popup {\n  p {\n    margin-top: 0;\n  }\n\n  .duplicate-document-popup-body {\n    display: flex;\n    flex-direction: column;\n    gap: 2.4rem;\n  }\n\n  .buttons {\n    margin-top: 3.2rem;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
